import WelcomeCall from './WelcomeCall'

export default WelcomeCall
